import * as types from '../constants/actionTypes';
import {
        DEFAULT_DEPOSITATE_STATE,
        DEFAULT_MAU_DEPOSIT_WITHDRAW_STATE,
        DEFAULT_TRADE_STATE,
        DEFAULT_REBATE_STATE,
        DEFAULT_FTD_STATE,
        DEFAULT_CCTRANSACTION_STATE,
        DEFAULT_CCWITHDRAWDETAIL_STATE,
        DEFAULT_FCS_DEPOSIT_WITHDRAW_STATE,
        DEFAULT_FCS_CCTRANSACTION_STATE,
        DEFAULT_FCS_CCDETAIL_STATE,
        DEFAULT_REPORT_DOWNLOAD_STATE,
} from "../constants/constants";

const initialState = {
  filters: {},
  sFilters: {},
  selectedCountries: [], // selected country items
  dataSourceList: [],
  currencyList: [],
  mt4AccountList: [],
  seletedMt4AccountList: [],
  countryList: [],
  paymentStatusList: [],
  continentsList: [],
  rebateState: DEFAULT_REBATE_STATE,
  tradeState: DEFAULT_TRADE_STATE,
  deposityState: DEFAULT_DEPOSITATE_STATE,
  mauDepositWithdrawState: DEFAULT_MAU_DEPOSIT_WITHDRAW_STATE,
  ftdState: DEFAULT_FTD_STATE,
  ccTransactionState: DEFAULT_CCTRANSACTION_STATE,
  ccWithdrawDetailState: DEFAULT_CCWITHDRAWDETAIL_STATE,
  userAndLevelName: "",
  levelId: "",
  showAll: true,
  mt4ServerList: [],
  seletedMt4ServerList: [],  
  actionList: [],
  seletedActionList: [],  
  selectedCreditCardChannel: "",
  selectedTransactionType: "",
  selectedCcStatus: "",
  selectedSourceDataVerifyStatus: "",
  ccWithdrawDetailChannelList: [],
  seletedCCWithdrawDetailChannelList: [],
  ccWithdrawDetailStatusList: [],
  seletedCCWithdrawDetailStatus: [],
  fcsDepositWithdrawState: DEFAULT_FCS_DEPOSIT_WITHDRAW_STATE,
  fcsCcTransactionState: DEFAULT_FCS_CCTRANSACTION_STATE,
  fcsCcDetailState: DEFAULT_FCS_CCDETAIL_STATE,
  reportDownloadState: DEFAULT_REPORT_DOWNLOAD_STATE,
  fcsSelectedCreditCardChannel: "",
  fcsSelectedCcTransactionType: "",
  fcsSelectedCreditCardStatus: "",
  fcsSelectedSourceDataVerifyStatus: "",
  fcsCcDetailChannelList: [],
  selectedFcsCCDetailChannelList: [],
  fcsCcDetailStatusList: [],
  selectedFcsCCDetailStatus: [],
}

export default function report(state = initialState, action) {
  switch(action.type) {
    case types.SET_FILTERS:
      return {
        ...state,
        filters: {...state.filters, ...action.filters}
      }
    case types.SET_S_FILTERS:
      return {
        ...state,
        sFilters: {...state.sFilters, ...action.sFilters}
      }
    case types.SET_DATA_SOURCE_LIST:
      return {
        ...state,
        dataSourceList: action.value
      }
    case types.SET_CURRENCY_LIST:
      return {
        ...state,
        currencyList: action.value
      }
    case types.SET_MT4_ACCOUNT_LIST:
      return {
        ...state,
        mt4AccountList: action.value
      }
    case types.SET_SELECTED_MT4_ACCOUNT_LIST:
      return {
        ...state,
        seletedMt4AccountList: action.value
      }
    case types.SET_MT4_SERVER_LIST:
      return {
        ...state,
        mt4ServerList: action.value
      }
    case types.SET_SELECTED_MT4_SERVER_LIST:
      return {
        ...state,
        seletedMt4ServerList: action.value
      }
    case types.SET_ACTION_LIST:
      return {
        ...state,
        actionList: action.value
      }
    case types.SET_SELECTED_ACTION_LIST:
      return {
        ...state,
        seletedActionList: action.value
      }
    case types.SET_COUNTRY_LIST:
      return {
        ...state,
        countryList: action.value
      }
    case types.SET_SELECTED_COUNTRIES:
      return {
        ...state,
        selectedCountries: action.value
      }
    case types.SET_CONTINENTS_LIST:
      return {
        ...state,
        continentsList: action.value
      }
    case types.SET_REBATE_STATE:
      return {
        ...state,
        rebateState: action.value
      }
    case types.SET_TRADE_STATE:
      return {
        ...state,
        tradeState: action.value
      }
    case types.SET_DEPOSITY_STATE:
      return {
        ...state,
        deposityState: action.value
      }
    case types.SET_MAU_DEPOSIT_WITHDRAW_STATE:
      return {
        ...state,
        mauDepositWithdrawState: action.value
      }
    case types.SET_FTD_STATE:
      return {
        ...state,
        ftdState: action.value
      }
    case types.SET_USER_AND_LEVEL_NAME:
      return {
        ...state,
        userAndLevelName: action.value
      }
    case types.SET_LEVEL_ID:
      return {
        ...state,
        levelId: action.value
      }
    case types.SET_SHOW_ALL:
      return {
        ...state,
        showAll: action.value
      }
    case types.SET_CCTRANSACTION_STATE:
      return {
        ...state,
        ccTransactionState: action.value
      }
    case types.SET_SELECTED_CREDITCARD_CHANNEL:
      return {
        ...state,
        selectedCreditCardChannel: action.value
      }
    case types.SET_SELECTED_CCTRANSACTION_TYPE:
      return {
        ...state,
        selectedTransactionType: action.value
      }
    case types.SET_SELECTED_CREDITCARD_STATUS:
      return {
        ...state,
        selectedCcStatus: action.value
      }
    case types.SET_SELECTED_SOURCEDATAVERIFY_STATUS:
      return {
        ...state,
        selectedSourceDataVerifyStatus: action.value
      }
    case types.SET_CCWITHDRAWDETAIL_STATE:
      return {
        ...state,
        ccWithdrawDetailState: action.value
      }
    case types.SET_CCWITHDRAWDETAIL_CHANNEL_LIST:
      return {
        ...state,
        ccWithdrawDetailChannelList: action.value
      }
    case types.SET_SELECTED_CCWITHDRAWDETAIL_CHANNEL_LIST:
      return {
        ...state,
        seletedCCWithdrawDetailChannelList: action.value
      }
    case types.SET_CCWITHDRAWDETAIL_STATUS_LIST:
      return {
        ...state,
        ccWithdrawDetailStatusList: action.value
      }
    case types.SET_SELECTED_CCWITHDRAWDETAIL_STATUS:
      return {
        ...state,
        seletedCCWithdrawDetailStatus: action.value
      }
    case types.SET_FCS_DEPOSIT_WITHDRAW_STATE:
      return {
        ...state,
        fcsDepositWithdrawState: action.value
      }
    case types.SET_FCS_CCTRANSACTION_STATE:
      return {
        ...state,
        fcsCcTransactionState: action.value
      }
    case types.SET_FCS_SELECTED_CREDITCARD_CHANNEL:
      return {
        ...state,
        fcsSelectedCreditCardChannel: action.value
      }
    case types.SET_FCS_SELECTED_CCTRANSACTION_TYPE:
      return {
        ...state,
        fcsSelectedCcTransactionType: action.value
      }
    case types.SET_FCS_SELECTED_CREDITCARD_STATUS:
      return {
        ...state,
        fcsSelectedCreditCardStatus: action.value
      }
    case types.SET_FCS_SELECTED_SOURCEDATAVERIFY_STATUS:
      return {
        ...state,
        fcsSelectedSourceDataVerifyStatus: action.value
      }
    case types.SET_FCS_CCDETAIL_STATE:
      return {
        ...state,
        fcsCcDetailState: action.value
      }
    case types.SET_FCS_CCDETAIL_CHANNEL_LIST:
      return {
        ...state,
        fcsCcDetailChannelList: action.value
      }
    case types.SET_FCS_SELECTED_CCDETAIL_CHANNEL_LIST:
      return {
        ...state,
        selectedFcsCCDetailChannelList: action.value
      }
    case types.SET_FCS_CCDETAIL_STATUS_LIST:
      return {
        ...state,
        fcsCcDetailStatusList: action.value
      }
    case types.SET_FCS_SELECTED_CCDETAIL_STATUS:
      return {
        ...state,
        selectedFcsCCDetailStatus: action.value
      }
    case types.SET_REPORT_DOWNLOAD_STATE:
      return {
        ...state,
        reportDownloadState: action.value
      }
    default:
      return state
  }
}